export default "__VITE_ASSET__3znr8yRN__"